<template>
     <a href="https://www.facebook.com/holisticsportcenter" target="_blank" rel="noopener noreferrer">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M22.25 12.3112C22.25 6.75444 17.7731 2.25 12.2512 2.25C6.72694 2.25125 2.25 6.75444 2.25 12.3125C2.25 17.3331 5.90704 21.4951 10.6864 22.25V15.2196H8.14926V12.3125H10.6889V10.094C10.6889 7.57309 12.1825 6.18076 14.466 6.18076C15.5608 6.18076 16.7044 6.37698 16.7044 6.37698V8.85168H15.4434C14.2023 8.85168 13.8148 9.62783 13.8148 10.424V12.3112H16.587L16.1445 15.2184H13.8136V22.2488C18.593 21.4938 22.25 17.3319 22.25 12.3112Z" fill="white"/>
</svg>
</a>
</template>

<script>
export default {
    name: 'FacebookIcon',
}

</script>